<template>
  <div class="list-page">
    <div class="detail-banner">
      <div class="container">
        <h1>出海研究报告</h1>
      </div>
    </div>

    <section class="section">
      <div class="container">
        <span class="detail-back" @click="$goBack()">‹ 返回</span>

        <div v-if="loading" class="empty-block">加载中…</div>

        <div v-else-if="rows.length" class="report-list">
          <div
            v-for="r in rows"
            :key="r.id"
            class="report-card"
            @click="openReport(r)"
          >
            <span class="report-tag" v-if="r.tag">{{ r.tag }}</span>
            <div class="report-title">{{ r.title }}</div>
            <div class="report-desc" v-if="r.summary">{{ r.summary }}</div>
            <div class="report-info">
              <span class="report-time" v-if="r.createTime">{{ r.createTime }}</span>
              <span class="report-view">查看报告 ›</span>
            </div>
          </div>

          <div class="disclaimer">
            注：本文为公开资料评论性解读，仅代表个人观点，仅供企业国际化交流参考，不构成任何决策建议。
          </div>
        </div>

        <div v-else class="empty-block">暂无报告</div>

        <!-- 分页 -->
        <div class="pager" v-if="totalPages > 1">
          <button class="pg-btn" :disabled="pageNum <= 1" @click="goPage(pageNum - 1)">‹ 上一页</button>
          <button
            v-for="p in pages"
            :key="p"
            class="pg-num"
            :class="{ active: p === pageNum }"
            @click="goPage(p)"
          >{{ p }}</button>
          <button class="pg-btn" :disabled="pageNum >= totalPages" @click="goPage(pageNum + 1)">下一页 ›</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { fetchOverseaReportPage } from '../api/home'

export default {
  name: 'OverseaReport',
  data () {
    return {
      rows: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      loading: true
    }
  },
  computed: {
    totalPages () {
      return Math.max(1, Math.ceil(this.total / this.pageSize))
    },
    pages () {
      const tp = this.totalPages
      const cur = this.pageNum
      if (tp <= 7) return Array.from({ length: tp }, (_, i) => i + 1)
      const set = new Set([1, tp, cur, cur - 1, cur + 1, cur - 2, cur + 2])
      const arr = [...set].filter(p => p >= 1 && p <= tp).sort((a, b) => a - b)
      const out = []
      let prev = 0
      for (const p of arr) {
        if (p - prev > 1) out.push('...')
        out.push(p)
        prev = p
      }
      return out
    }
  },
  created () {
    this.load()
  },
  methods: {
    async load () {
      this.loading = true
      try {
        const res = await fetchOverseaReportPage({
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
        this.rows = res.rows
        this.total = res.total
      } catch (e) {
        this.rows = []
        this.$toast.show({ message: (e && e.message) || '加载失败', type: 'error' })
      } finally {
        this.loading = false
      }
    },
    openReport (r) {
      if (r.url) {
        window.open(r.url, '_blank')
      } else {
        this.$toast.show({ message: '报告地址暂不可用', type: 'info' })
      }
    },
    goPage (p) {
      if (p < 1 || p > this.totalPages || p === this.pageNum) return
      this.pageNum = p
      this.load()
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style scoped>
.report-list {
  margin-top: 8px;
}
.report-card {
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 16px;
  box-shadow: var(--shadow);
  padding: 24px 26px;
  margin-bottom: 16px;
  cursor: pointer;
  transition: box-shadow 0.25s ease, transform 0.25s ease;
}
.report-card:hover {
  box-shadow: var(--shadow-hover);
  transform: translateY(-2px);
}
.report-tag {
  display: inline-block;
  font-size: 12.5px;
  color: var(--primary);
  background: var(--blue-soft);
  padding: 4px 12px;
  border-radius: 6px;
  margin-bottom: 12px;
}
.report-title {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-main);
  line-height: 1.45;
  margin-bottom: 12px;
}
.report-desc {
  font-size: 14px;
  color: var(--text-sub);
  line-height: 1.7;
  margin-bottom: 18px;
  word-break: break-all;
}
.report-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.report-time {
  font-size: 13px;
  color: #9aa6c0;
}
.report-view {
  font-size: 14px;
  font-weight: 700;
  color: var(--primary);
}
.disclaimer {
  font-size: 12.5px;
  color: #9aa6c0;
  text-align: center;
  padding: 20px 0 4px;
  line-height: 1.6;
}
.pager {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 34px;
  flex-wrap: wrap;
}
.pg-btn,
.pg-num {
  min-width: 38px;
  height: 38px;
  padding: 0 12px;
  border: 1px solid var(--border);
  background: #fff;
  color: var(--text-main);
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.pg-btn:hover:not(:disabled),
.pg-num:hover {
  border-color: var(--primary);
  color: var(--primary);
}
.pg-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.pg-num.active {
  background: var(--primary);
  border-color: var(--primary);
  color: #fff;
}
.pager :not(button) {
  color: var(--text-sub);
  padding: 0 4px;
}
</style>
